<template>
  <div>
    <van-nav-bar
      title="划转"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/agency')"
    />
    <van-form>
      <van-cell title="账户余额">
        <template #default>
          <span>{{ agent_account }}元</span>
        </template>
      </van-cell>
      <van-field
        v-model="money"
        error
        required
        type="digit"
        placeholder="请输入划转金额"
        input-align="right"
      >
      <template #label>
       <div style="width:100px;">划转金额</div> 
      </template>
      </van-field>
      <van-row>
          <van-col span="8"></van-col>
          <!-- <van-col span="9">
              <van-button size="small" round  type="danger" block @click="withdrawalMoney" class="black">提现</van-button>
          </van-col>
          <van-col span="2"></van-col> -->
          <van-col span="8">
              <van-button size="small" round  type="danger" block @click="transferMoney" class="black">划转</van-button>
          </van-col> 
          <van-col span="8"></van-col>
      </van-row>
      <van-row>
        <van-col span="24">
          <p class="transferWithdrawalText">资金划转：资金从推广账户划转到会员账户，即时到账。</p>
        </van-col>
      </van-row>
    </van-form>
  </div>
</template>

<script>
import { Dialog } from "vant";
    export default {
      name: "AgencyTransferWithdrwal",
      data(){
        return{
          agent_account:'',
          money:'',
        }
      },
      methods:{
        isLogin(){
          let that = this;
          if (!that.$store.state.loginType){
            that.$router.push('/login')
          }
        },
        transferMoney(){
            let that = this;
            if(!that.money){
              that.$toast.fail("您输入的划转金额有误");
            }else{
            Dialog.confirm({
              title: "确认划转",
              message:
                "您是否确定划转"+that.money+"资金到您的会员账号?",
              cancelButtonText: "取消",
              confirmButtonText: "确定",
            })
              .then(() => {
                that.transfer();
              })
              .catch(() => {});
            }
        },
        withdrawalMoney(){
            let that = this;
            if(!that.money){
              that.$toast.fail("您输入的金额有误");
            }else{
            Dialog.confirm({
              title: "确认提现",
              message:
                "您是否确定提现"+that.money+"吗?",
              cancelButtonText: "取消",
              confirmButtonText: "确定",
            })
              .then(() => {
                that.Withdrawal();
              })
              .catch(() => {});
            }
        },
        getUser() {
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "user",
                token: sessionStorage.getItem("token")
              }
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.code === 1) {
                that.agent_account = resData.data.agent_account;
              } else if (res.data.code === 0 || res.data.code === -1) {
                that.$toast.fail(resData.msg);
              }
            })
            .catch(()=>{
              that.$toast.fail(that.$NoNetworkErrorMsg)
            })
        },
        transfer(){
          let that = this;
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "transfer_money",
              token: sessionStorage.getItem("token"),
              number: that.money,
            }
          })
            .then(function(res) {
              if (res.data.code == 1) {
                that.$toast.success({
                  message: res.data.msg,
                  onClose:function () {
                    that.$router.push('/member/agency')
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            })
            .catch(()=>{
              that.$toast.fail(that.$NoNetworkErrorMsg)
            })

        },
        Withdrawal() {
        let that = this;
        that.$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "accountbank",
            token: sessionStorage.getItem("token")
          }
        })
          .then(function(res) {
            if (res.data.code == 1) {
              let resData = res.data;
              if (resData.data.length === 0){
                that.$toast({
                  type:'fail',
                  message:'还未绑定银行卡,请前去绑定银行卡才可提现',
                  onClose:function () {
                    that.$router.push('/member/information');
                  }
                });
              }else{
                let bankCardList = res.data.data;
                // that.bankCardList = res.data.data;
                let card = bankCardList[0].card;
                let name = bankCardList[0].name;

                that.$http({
                  url: "/",
                  method: "post",
                  data: {
                    nozzle: "agent_dowithdraw",
                    token: sessionStorage.getItem("token"),
                    number: that.money,
                    password: that.password,
                    name: name,
                    card: card
                  }
                })
                  .then(function(res) {
                    if (res.data.code == 1) {
                      that.$toast.success({
                        message: res.data.msg,
                        onClose:function () {
                          that.$router.push('/member/agency')
                        }
                      });
                    } else if (res.data.code == 0 || res.data.code == -1) {
                      that.$toast.fail(res.data.msg);
                    }
                  });
              }


            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(res.data.msg);
            }
          })
          .catch(()=>{
              that.$toast.fail(that.$NoNetworkErrorMsg)
          })

      }
      },
      mounted:function () {
        this.isLogin();
        this.getUser();
      }
    }
</script>

<style scoped>
.black{
    color: #ffffff;
}
.transferWithdrawalText{
    padding-left:15px;
    padding-right:15px;
    font-size:12px;
}
</style>



// WEBPACK FOOTER //
// src/components/AgencyTransferWithdrawal.vue